document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.everyday-elegance').forEach(initEverydayElegance);
});

function initEverydayElegance(root) {
  const track = root.querySelector('.everyday-elegance__track');
  const prevBtn = root.querySelector('.everyday-elegance__arrow--prev');
  const nextBtn = root.querySelector('.everyday-elegance__arrow--next');
  if (!track || !prevBtn || !nextBtn) return;

  const slideWidth = () => {
    const first = track.querySelector('.everyday-elegance__slide');
    return first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
  };

  const updateButtons = () => {
    const max = track.scrollWidth - track.clientWidth - 2;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= max;
  };

  prevBtn.addEventListener('click', () => {
    track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', () => {
    track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', () => window.requestAnimationFrame(updateButtons));
  window.addEventListener('resize', updateButtons);
  updateButtons();

  if (root.dataset.autoplay === 'true') {
    const speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    let timer = setInterval(advance, speed);

    function advance() {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      }
    }

    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', () => {
      timer = setInterval(advance, speed);
    });
  }
}
